import { co2 } from './common';

export default {
  'consumption.co2': `Ortalama ${co2} emisyonu`,
  'consumption.energy': 'Ortalama elektrik tüketimi',
  'consumption.fuel': 'Ortalama yakıt tüketimi',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': `Belirtilen değerler, öngörülen ölçme yöntemine göre belirlenmiştir. 2017/1153 sayılı uygulama direktifinin (AB) 2. maddesinin 1 numaralı hükmüne göre “NEFZ-${co2} değerleri” söz konusudur. Bilgiler, münferit bir araç ile ilgili olmayıp, bir teklifin parçası değildir; sadece çeşitli araç tipleri arasında karşılaştırma yapma amacına hizmet ederler. Değerler, seçilen özel donanımlara göre farklılık göstermektedir.`,
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Online kod ara / Web sitesinde ara',
  'search.result.buy-online': 'Online Satın Al',
  'search.results': 'Sonuç bulunamadı | {count} arama sonucu | {count} arama sonucu',
  'search.results.backup': 'Aramanızla eşleşen sonuç bulunamadı. İlgili sayfaları inceleyin:',
  'search.results.count': '{count} arama sonucu',
  'search.results.none.summary':
    'Arama teriminizi içeren sonuç bulunamadı. Farklı bir terim ile tekrar aramayı deneyin.',
  'search.show-more': 'Daha fazlasını görüntüle.',
  'search.unavailable': 'Arama fonksiyonu şu anda çalışmıyor.',
  'search.result.new': 'Yeni',

  'input.placeholder': 'Online kod ara / Web sitesinde ara',

  'search.result.consumption': 'Tüketim',
  'watch.video': 'Videoyu izleyin',
  'input.recently': 'Son Arananlar',
  'input.help.title': 'Neyi aramalısınız?',
  'input.help.text':
    'Araç tipleri, modelleri ve yapılandırma kodlarını kullanarak veya aksesuarlar, diğer ürünler ve bilgiler için arama yapın',

  'search.result.grid': 'Izgara',
  'search.result.list': 'Liste',

  // No results
  'support.check': 'Lütfen yazım hatalarını kontrol edin veya farklı bir terimle devam edin.',
  'support.no.results': 'Bu arama terimi için herhangi bir arama sonucu yok.',
  'support.no.results.term': 'Sonuç bulunamadı',
  'support.chat': 'Aradığınızı bulamıyorum? Lütfen Online Sohbet',
  'support.chat.with.us': 'Desteğimizi kullanın',
};
